import { HttpBackend, HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppLocalStorage } from "app/app-storage-manager/local-storage";
import { environment } from "environments/environment";
import { BehaviorSubject } from "rxjs";
import { Store } from "@ngrx/store";
import { AppState } from "../reducers";
import { retry } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class MiscService {
  user = undefined;
  userSubject = new BehaviorSubject(this.user);
  name: string;
  private httpBackendClient: HttpClient;

  GLOBAL_PASTOR_SUBMENU = [
    {
      path: "/app/dashboard/management/branch",
      title: "Branches",
    },
    {
      path: "/app/dashboard/management/area",
      title: "Areas",
    },
    {
      path: "/app/dashboard/management/zone",
      title: "Zones",
    },
    {
      path: "/app/dashboard/management/cell",
      title: "Cells",
    },
    {
      path: "/app/dashboard/management/admins",
      title: "Pending Verification",
    },
    {
      path: "/app/dashboard/management/users/all",
      title: "Users",
    },
    // {
    //   path: "/app/dashboard/management/members",
    //   title: "Members",
    // },
  ];
  NATIONAL_PASTOR_SUBMENU = [
    {
      path: "/app/dashboard/management/branch",
      title: "Branches",
    },
    {
      path: "/app/dashboard/management/area",
      title: "Areas",
    },
    {
      path: "/app/dashboard/management/zone",
      title: "Zones",
    },
    {
      path: "/app/dashboard/management/cell",
      title: "Cells",
    },
    {
      path: "/app/dashboard/management/admins",
      title: "Pending Verification",
    },
    {
      path: "/app/dashboard/management/users/all",
      title: "Users",
    },
    {
      path: "/app/dashboard/management/new-converts",
      title: "New-converts",
    },
  ];

  RESIDENTIAL_PASTOR_SUBMENU = [
    {
      path: "/app/dashboard/management/clusters",
      title: "Clusters",
    },
    {
      path: "/app/dashboard/management/area",
      title: "Areas",
    },
    {
      path: "/app/dashboard/management/zone",
      title: "Zones",
    },
    {
      path: "/app/dashboard/management/cell",
      title: "Cells",
    },
    {
      path: "/app/dashboard/management/admins",
      title: "Pending Verification",
    },
    {
      path: "/app/dashboard/management/users/all",
      title: "Users",
    },
    {
      path: "/app/dashboard/management/new-converts",
      title: "New-converts",
    },
    // {
    //   path: "/app/dashboard/management/members",
    //   title: "Members",
    // },
  ];

  CLUSTER_PASTOR_SUBMENU = [
    {
      path: "/app/dashboard/management/area",
      title: "Areas",
    },
    {
      path: "/app/dashboard/management/zone",
      title: "Zones",
    },
    {
      path: "/app/dashboard/management/cell",
      title: "Cells",
    },
  ];

  AREA_PASTOR_SUBMENU = [
    {
      path: "/app/dashboard/management/zone",
      title: "Zones",
    },
    {
      path: "/app/dashboard/management/cell",
      title: "Cells",
    },
    {
      path: "/app/dashboard/management/admins",
      title: "Pending Verification",
    },
    {
      path: "/app/dashboard/management/users/all",
      title: "Users",
    },
    {
      path: "/app/dashboard/management/new-converts",
      title: "New-converts",
    },
    // {
    //   path: "/app/dashboard/management/members",
    //   title: "Members",
    // },
  ];

  ZONAL_PASTOR_SUBMENU = [
    {
      path: "/app/dashboard/management/cell",
      title: "Cells",
    },
    {
      path: "/app/dashboard/management/users/all",
      title: "Users",
    },
    {
      path: "/app/dashboard/management/admins",
      title: "Pending Verification",
    },
    {
      path: "/app/dashboard/management/new-converts",
      title: "New-converts",
    },
    // {
    //   path: "/app/dashboard/management/pastors/all",
    //   title: "Pastors",
    // },
    // {
    //   path: "/app/dashboard/management/members",
    //   title: "Members",
    // },
  ];

  // GB MANAGEMENT SUBMENU

  NATIONAL_PASTOR_UK_SUBMENU = [
    {
      path: "/app/dashboard/management/branch",
      title: "Branches",
    },
    {
      path: "/app/dashboard/management/area",
      title: "Province",
    },
    {
      path: "/app/dashboard/management/hfc",
      title: "HFC",
    },
    {
      path: "/app/dashboard/management/district",
      title: "District",
    },
    {
      path: "/app/dashboard/management/zone",
      title: "Zones",
    },
    {
      path: "/app/dashboard/management/cell",
      title: "Cells",
    },
    {
      path: "/app/dashboard/management/admins",
      title: "Pending Verification",
    },
    {
      path: "/app/dashboard/management/users/all",
      title: "Users",
    },
    {
      path: "/app/dashboard/management/new-converts",
      title: "New-converts",
    },
  ];

  RESIDENTIAL_PASTOR_UK_SUBMENU = [
    {
      path: "/app/dashboard/management/area",
      title: "Province",
    },
    {
      path: "/app/dashboard/management/hfc",
      title: "HFC",
    },
    {
      path: "/app/dashboard/management/district",
      title: "District",
    },
    {
      path: "/app/dashboard/management/zone",
      title: "Zones",
    },
    {
      path: "/app/dashboard/management/cell",
      title: "Cells",
    },
    {
      path: "/app/dashboard/management/admins",
      title: "Pending Verification",
    },
    {
      path: "/app/dashboard/management/users/all",
      title: "Users",
    },
    {
      path: "/app/dashboard/management/new-converts",
      title: "New-converts",
    },
    // {
    //   path: "/app/dashboard/management/members",
    //   title: "Members",
    // },
  ];

  AREA_PASTOR_UK_SUBMENU = [
    {
      path: "/app/dashboard/management/district",
      title: "District",
    },
    {
      path: "/app/dashboard/management/zone",
      title: "Zones",
    },
    {
      path: "/app/dashboard/management/cell",
      title: "Cells",
    },
    {
      path: "/app/dashboard/management/admins",
      title: "Pending Verification",
    },
    {
      path: "/app/dashboard/management/users/all",
      title: "Users",
    },
    {
      path: "/app/dashboard/management/new-converts",
      title: "New-converts",
    },
    // {
    //   path: "/app/dashboard/management/members",
    //   title: "Members",
    // },
  ];

  DISTRICT_PASTOR_UK_SUBMENU = [
    {
      path: "/app/dashboard/management/district",
      title: "District",
    },
    {
      path: "/app/dashboard/management/zone",
      title: "Zones",
    },
    {
      path: "/app/dashboard/management/cell",
      title: "Cells",
    },
    {
      path: "/app/dashboard/management/admins",
      title: "Pending Verification",
    },
    {
      path: "/app/dashboard/management/users/all",
      title: "Users",
    },
    {
      path: "/app/dashboard/management/new-converts",
      title: "New-converts",
    },
    // {
    //   path: "/app/dashboard/management/members",
    //   title: "Members",
    // },
  ];

  ZONAL_PASTOR_UK_SUBMENU = [
    {
      path: "/app/dashboard/management/cell",
      title: "Cells",
    },
    {
      path: "/app/dashboard/management/admins",
      title: "Pending Verification",
    },
    {
      path: "/app/dashboard/management/new-converts",
      title: "New-converts",
    },
    // {
    //   path: "/app/dashboard/management/pastors/all",
    //   title: "Pastors",
    // },
    // {
    //   path: "/app/dashboard/management/members",
    //   title: "Members",
    // },
  ];

  private readonly REPORT_BASE_URL = `${environment.BASE_URL}/cmp-report`;
  private readonly AUTH_BASE_URL = `${environment.BASE_URL}/cmp-auth/v2`;

  constructor(
    private appStorage: AppLocalStorage,
    private http: HttpClient,
    private httpBackend: HttpBackend,
    private store: Store<AppState>,
  ) {
    this.httpBackendClient = new HttpClient(httpBackend);
  }

  formatCallingCode = (callingCode: string) => {
    if (callingCode == null || callingCode.length > 2) {
      return callingCode;
    }

    if (callingCode.length == 2) {
      return `0${callingCode}`;
    }

    if (callingCode.length == 1) {
      return `00${callingCode}`;
    }
  };

  public getLoggedInUserDetails = () => {
    return this.appStorage.getFromStorage("user");
  };

  fetchZoneById = (id) => {
    this.http
      .get(`${this.REPORT_BASE_URL}/church/zone/${id}`)
      .pipe(retry(2))
      .subscribe((response: any) => {
        return response;
      });
  };

  updateUser = (update) => {
    this.user = update;
    this.userSubject.next(this.user);
    this.appStorage.storeToStorage("user", this.user);
  };

  genRandomString = (length) =>
    Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))
      .toString(36)
      .slice(1);

  numberWithCommas = (x) => {
    if (!x) {
      return "0";
    }
    let parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    parts = parts.join(".");
    if (parts.includes(".")) {
      return parts;
    } else {
      return parts + ".00";
    }
  };

  formatDateAndTime = (date: string | null) => {
    if (!date) {
      return "";
    }
    const dateToFormat = new Date(date);
    return (
      dateToFormat.toDateString() + " " + dateToFormat.toLocaleTimeString()
    );
  };

  formatDate = (date: string | null) => {
    if (!date) {
      return "";
    }
    const dateToFormat = new Date(date);
    return dateToFormat.toDateString();
  };

  formatTime = (date: string | null) => {
    if (!date) {
      return "";
    }
    const dateToFormat = new Date(date);
    return dateToFormat.toLocaleTimeString();
  };

  formatTo2DecimalPlaces = (number: any) => {
    if (!number) {
      return;
    }
    number = number.toString();
    if (number.includes(".")) {
      number = parseFloat(number);
      return number.toFixed(2).toString();
    } else {
      return number + ".00";
    }
  };

  formatCountryCode = (countryCode) => {
    return countryCode.length === 1
      ? "00" + countryCode
      : countryCode.length === 2
        ? "0" + countryCode
        : countryCode;
  };

  getCountries = () => {
    return this.http.get(`${this.REPORT_BASE_URL}/v2/common/list-countries`);
  };

  getState = (iso) =>
    this.http.get(`${this.REPORT_BASE_URL}/v2/common/get-states/${iso}`);

  uploadImage = (payload) =>
    this.http.post(`${this.AUTH_BASE_URL}/common/upload`, payload);

  public userTypeObj = {
    USER: "User",
    GLOBAL_ADMIN: "Continent",
    CONTINENTAL_ADMIN: "Nation",
    COUNTRY_ADMIN: "Church",
    CHURCH_ADMIN: "Area",
    AREA_ADMIN: "District",
    DISTRICT_ADMIN: "Zone",
    ZONAL_ADMIN: "WSF",
  };

  loadUserTypes = (data) => {
    switch (data.role) {
      case "Global Pastor":
        this.name = "nation";
        break;
      case "National Pastor":
        this.name = "residential";
        break;
      case "Resident Pastor":
        this.name = "area";
        break;
      case "Area Pastor":
        this.name = "zone";
        break;
      case "Mission Pastor":
        this.name = "zone";
        break;
      case "Zonal Pastor":
        this.name = "Wsf";
        break;

      default:
        break;
    }
  };

  getPastorfilter = () => {
    const user = this.getLoggedInUserDetails()?.role;

    // if (user === "Global Pastor") return "National Admins";
    if (user === "National Pastor") return "Resident Pastor";
    if (user === "Resident Pastor") return "Area Pastor";
    if (user === "Area Pastor" || user === "Mission Pastor")
      return "Zonal Admin";
    if (user === "Zonal Admin") return "Cell Minister";
    if (user === "Cell Minister") return "Pastor";
  };

  getManagementSubMenus() {
    const user = this.getLoggedInUserDetails();

    if (user.country === "NG") {
      if (user?.role === "Global Pastor") return this.NATIONAL_PASTOR_SUBMENU;
      if (user?.role === "National Pastor") return this.NATIONAL_PASTOR_SUBMENU;
      if (user?.role === "Resident Pastor")
        return this.RESIDENTIAL_PASTOR_SUBMENU;
      if (user?.clusterPastor) return this.CLUSTER_PASTOR_SUBMENU;
      if (user?.role === "Area Pastor" || user?.role === "Mission Pastor")
        return this.AREA_PASTOR_SUBMENU;
      if (user?.role === "Zonal Pastor") return this.ZONAL_PASTOR_SUBMENU;
    } else {
      if (user.role === "Global Pastor") return this.NATIONAL_PASTOR_SUBMENU;
      if (user.role === "National Pastor")
        return this.NATIONAL_PASTOR_UK_SUBMENU;
      if (
        user.role === "Resident Pastor" ||
        user.role === "Assistant Pastor" ||
        user.role === "Associate Pastor"
      )
        return this.RESIDENTIAL_PASTOR_UK_SUBMENU;
      if (
        user.role === "Area Pastor" ||
        user.role === "Mission Pastor" ||
        user.role === "Province Pastor"
      )
        return this.AREA_PASTOR_UK_SUBMENU;
      if (user.role === "District Pastor")
        return this.DISTRICT_PASTOR_UK_SUBMENU;
      if (user.role === "Zonal Pastor") return this.ZONAL_PASTOR_UK_SUBMENU;
      if (user.role === "HFC Pastor") return this.ZONAL_PASTOR_UK_SUBMENU;
    }
  }

  // getGBManagementSubMenus() {
  //   const user = this.getLoggedInUserDetails()?.role;
  // }

  normalizePhoneNumber(phone: string): string {
    if (!phone) return "";
    phone = phone.replace(/^\+/, ""); // remove leading +
    if (phone.startsWith("0")) {
      phone = "234" + phone.substring(1);
    } else if (!phone.startsWith("234")) {
      phone = "234" + phone;
    }
    // Ensure it's 13 digits; if not, return as is (assuming user input is correct)
    return phone;
  }
}
